import React, { FC, useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import Select from 'react-select';
import { fetchData, fetchFormData, hasSpecialCharacters, isSpecificSpecialCharacters, toasterrormsg, toastsuccessmsg } from '../../../reusable';
import { ToastContainer } from 'react-toastify';
import { AddCarRentalHeader } from './AddCarRentalHeader';
import { KTIcon, toAbsoluteUrl } from '../../../_metronic/helpers';
import PhoneInput from 'react-phone-input-2';
import { Tr } from '../../../_metronic/i18n/Tr';
import Swal from 'sweetalert2';

const AddCarRentalBasicInfo: FC = () => {

    const t = Tr()
    const navigate = useNavigate()
    const categoryId = sessionStorage.getItem('categoryId');
    useEffect(() => {
        if (categoryId != '7') {
            navigate('../dashboard/');
        }
    }, [categoryId])
    const location = useLocation();
    const editCarrentalId = (location.state as any)?.carrentalId || '';

    var vendorId = "";
    const vendorData = sessionStorage.getItem("vendor");
    if (vendorData) {
        var vendor = JSON.parse(vendorData);
        vendorId = vendor.vendorId;

    } else {
        console.log("No vendor data found");
    }
    const [loading, setLoading] = useState(false)
    const [disable, setDisable] = useState(false);
    const [supplierImage, setSupplierImage] = useState()
    const [supplierImageUrl, setSupplierImageUrl] = useState("");
    const [carRentalDetails, setCarRentalDetails] = useState([]);
    const [carSupplierNameEN, setCarSupplierNameEN] = useState("");
    const [carSupplierNameRU, setCarSupplierNameRU] = useState("");
    const [carSupplierNameUZ, setCarSupplierNameUZ] = useState("");
    const [contactPersonName, setContactPersonName] = useState("");
    const [email, setEmail] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("998");
    const [isFieldDisable, setIsFieldDisable] = useState({
        carSupplierNameEN: false,
        carSupplierNameRU: false,
        carSupplierNameUZ: false,
        contactPersonName: false,
    }) as any

    const [primaryLanguageList] = useState([
        { value: 'English', label: 'English' },
        { value: 'Russian', label: 'Русский' },
        { value: 'Uzbek', label: 'O’zbekcha' },
    ]);
    const [primaryLanguageSelectedOptions, setPrimaryLanguageSelectedOptions] = useState<any>({ value: 'English', label: 'English' });
    sessionStorage.setItem("primaryLanguage", primaryLanguageSelectedOptions.value);

    // service language list state end
    const changePrimaryLanguage = (val: any) => {
        setPrimaryLanguageSelectedOptions(val);
        removeError("primaryLanguage");
        sessionStorage.setItem("primaryLanguage", val.value);
    }

    const [socialMediaChannelList] = useState([
        { label: 'Instagram', value: 'Instagram' },
        { label: 'Facebook', value: 'Facebook' },
        { label: 'Linkedin', value: 'Linkedin' },
        { label: 'TikTok', value: 'TikTok' },
        { label: 'YouTube', value: 'YouTube' },
        { label: 'Website', value: 'Website' }]);

    const [socialMediaFields, setSocialMediaFields] = useState([
        { socialMediaType: '', socialMediaLink: '' }
    ]) as any;
    const [errors, setErrors] = useState([{
        socialMediaType: '',
        socialMediaLink: '',
    }]);

    const removeErrors = (index: any, fieldName: any) => {
        let newError = [...errors] as any;
        if (!newError[index]) {
            newError[index] = {};
        }
        newError[index][fieldName] = ''; // Clear error
        setErrors(newError);
    };
    const handleAddField = () => {
        setSocialMediaFields([...socialMediaFields, { socialMediaType: '', socialMediaLink: '' }]);
    };

    const handleRemoveField = (index: any) => {
        const updatedFields = socialMediaFields.filter((_: any, i: any) => i !== index);
        setSocialMediaFields(updatedFields);
    };

    const handleChange = (index: any, field: any, value: any) => {
        const updatedFields = [...socialMediaFields] as any;
        updatedFields[index][field] = value;
        setSocialMediaFields(updatedFields);
        removeErrors(index, field); // Clear the error for the updated field
    };

    const getFilteredOptions = (currentIndex: any) => {
        const selectedValues = socialMediaFields.map((field: any, index: any) => index !== currentIndex ? field.socialMediaType : '');
        return socialMediaChannelList.filter(option => !selectedValues.includes(option.value));
    };
    // set error state
    const [error, setError] = useState([{
        image: '',
        carSupplierNameEN: '',
        carSupplierNameRU: '',
        carSupplierNameUZ: '',
        contactPersonName: '',
        email: '',
        phoneNumber: '',
        primaryLanguage: '',
    }])

    // remove validation function
    const removeError = (err: any) => {
        var tmp = [...error] as any;
        tmp[0][err] = "";
        setError(tmp);
    }

    // validation function
    const validate = () => {

        var isValid = true;
        var errorTmp = [...error];

        if ((supplierImage == null || supplierImage == undefined) && (supplierImageUrl === "" || supplierImageUrl === null)) {
            errorTmp[0].image = t('Image Is Required');
            isValid = false;
        }
        if ((supplierImage == null || supplierImage == undefined) && (supplierImageUrl === "" || supplierImageUrl === null)) {
            errorTmp[0].image = t('Image Is Required');
            isValid = false;
        }
        if (primaryLanguageSelectedOptions.value == "English") {

            if (carSupplierNameEN.trim() == "" || carSupplierNameEN.trim() == null || carSupplierNameEN.trim() == undefined) {
                errorTmp[0].carSupplierNameEN = t('Supplier Name Is Required');
                isValid = false;
            } 
            // else if (!isSpecificSpecialCharacters(carSupplierNameEN.trim())) {
            //     errorTmp[0].carSupplierNameEN = t("Only <>,.'*() type Of Special Character Are Allow.");
            //     isValid = false;
            // }
        } else if (primaryLanguageSelectedOptions.value == "Russian") {
            if (carSupplierNameRU.trim() == "" || carSupplierNameRU.trim() == null || carSupplierNameRU.trim() == undefined) {
                errorTmp[0].carSupplierNameRU = t('Supplier Name Is Required');
                isValid = false;
            } 
            // else if (!hasSpecialCharacters(carSupplierNameRU.trim())) {
            //     errorTmp[0].carSupplierNameRU = t('Special Characters Is Not Allow');
            //     isValid = false;
            // }
        } else if (primaryLanguageSelectedOptions.value == "Uzbek") {
            if (carSupplierNameUZ.trim() == "" || carSupplierNameUZ.trim() == null || carSupplierNameUZ.trim() == undefined) {
                errorTmp[0].carSupplierNameUZ = t('Supplier Name Is Required');
                isValid = false;
            }
            //  else if (!hasSpecialCharacters(carSupplierNameUZ.trim())) {
            //     errorTmp[0].carSupplierNameUZ = t('Special Characters Is Not Allow');
            //     isValid = false;
            // }
        }
        if (contactPersonName.trim() == "" || contactPersonName.trim() == null || contactPersonName.trim() == undefined) {
            errorTmp[0].contactPersonName = t('Person Name Is Required');
            isValid = false;
        } else if (!hasSpecialCharacters(contactPersonName.trim())) {
            errorTmp[0].contactPersonName = t('Special Characters Is Not Allow');
            isValid = false;
        }
        if (email == "" || email == undefined || email == null) {
            errorTmp[0].email = t('Email Is Required');
            isValid = false;
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}(?:\.[A-Z]{2,})?$/i.test(email)) {
            errorTmp[0].email = t('Please Enter Valid Email.');
            isValid = false;
        }
        if (!phoneNumber) {
            errorTmp[0].phoneNumber = t('Mobile Number Is Required');
            isValid = false;
        } else if (!/^\d+$/.test(phoneNumber)) {
            errorTmp[0].phoneNumber = t('Only Numbers Are Allowed.');
            isValid = false;
        } else {
            // Remove non-numeric characters (like + or spaces)
            const numericPhone = phoneNumber.replace(/\D/g, '');
            // Validate phone number length
            if (numericPhone.length < 10 || numericPhone.length > 15) {
                errorTmp[0].phoneNumber = t('Please Enter Valid Mobile Number');
                isValid = false;
            }
        }
        let errorTmps = [...errors] as any;

        socialMediaFields.forEach((field: any, index: any) => {
            if (!errorTmps[index]) {
                errorTmps[index] = {};
            }

            // Validate socialMediaType field
            if (!field.socialMediaType) {
                errorTmps[index].socialMediaType = t('Social Media Type Is Required');
                isValid = false;
            } else {
                errorTmps[index].socialMediaType = ''; // Clear error if socialMediaType is selected
            }

            // Validate socialMediaLink field
            if (!field.socialMediaLink || !field.socialMediaLink.trim()) {
                errorTmps[index].socialMediaLink = t('Social Media Link Is Required');
                isValid = false;
            } else {
                errorTmps[index].socialMediaLink = ''; // Clear error if socialMediaLink is provided
            }
        });

        setErrors(errorTmps);
        setError(errorTmp);
        return isValid;
    }
    // add restaurant api call
    const addCarRentalApi = async () => {

        if (validate()) {
            setDisable(true)
            setLoading(true);
            const param = new FormData()
            param.append("vendorId", String(vendorId))
            param.append("en_supplierName", carSupplierNameEN)
            param.append("ru_supplierName", carSupplierNameRU)
            param.append("uz_supplierName", carSupplierNameUZ)
            param.append("primaryLanguage", primaryLanguageSelectedOptions.value)
            param.append("email", email)
            param.append("phoneNo", phoneNumber)
            param.append("contact_person_name", contactPersonName)
            param.append("socialMediaChannels", JSON.stringify(socialMediaFields))

            if (supplierImage) {
                param.append("image", supplierImage)
            }
            var res = await fetchFormData("public/addCarRental", param)
            if (res.status == "200") {
                toastsuccessmsg(t("Basic Information Saved Successfully!"))
                var data = res.data[0];
                const state = {
                    carrentalId: data['carrentalId']
                }
                setTimeout(() => {
                    if (data.isCriticalFieldChange) {
                        navigate("../viewcarcontract/", { state });
                    } else {
                        navigate("../addcarrentallocation/", { state });
                    }
                    setDisable(false)
                    setLoading(false)
                }, 1500);
            }
            else {
                setLoading(false)
                setDisable(false)
                toasterrormsg(res.message)
            }
        }

    }
    // edit restaurant api call
    const editCarRentalApi = async () => {

        if (validate()) {
            setDisable(true)
            setLoading(true);
            const param = new FormData()
            param.append("vendorId", String(vendorId))
            param.append("carrentalId", editCarrentalId)
            param.append("en_supplierName", carSupplierNameEN)
            param.append("ru_supplierName", carSupplierNameRU)
            param.append("uz_supplierName", carSupplierNameUZ)
            param.append("primaryLanguage", primaryLanguageSelectedOptions.value)
            param.append("email", email)
            param.append("phoneNo", phoneNumber)
            param.append("contact_person_name", contactPersonName)
            param.append("socialMediaChannels", JSON.stringify(socialMediaFields))
            if (supplierImage) {
                param.append("image", supplierImage)
            }

            var res = await fetchFormData("public/addCarRental", param)
            if (res.status == "200") {
                toastsuccessmsg(t("Basic Information Saved Successfully!"))
                var data = res.data[0];
                const state = {
                    carrentalId: data['carrentalId']
                }
                setTimeout(() => {
                    if (data.isCriticalFieldChange) {
                        navigate("../viewcarcontract/", { state });
                    } else {
                        navigate("../addcarrentallocation/", { state });
                    }
                    setDisable(false)
                    setLoading(false)
                }, 1500);
            }
            else {
                setLoading(false)
                setDisable(false)
                toasterrormsg(res.message)
            }
        }

    }
    // space Details api call
    const carRentalDetailApiCall = async () => {

        var param: any = {
            carrentalId: String(editCarrentalId),
        }
        var response: any = await fetchData("public/carRentalDetail", param)

        if (response.status == "200") {
            setCarRentalDetails(response.data);
            var data = response.data[0];
            const isAllStepsCompleted = Object.values(data['completedSteps']).every(s => s == true)
            if (isAllStepsCompleted && editCarrentalId !== "") {
                // Set all fields to true
                setIsFieldDisable((prev: any) => {
                    const updatedFields = {} as any;
                    for (const key in prev) {
                        updatedFields[key] = true;
                    }
                    return updatedFields;
                });
            }
            setPrimaryLanguageSelectedOptions({ value: data.primaryLanguage, label: `${data.primaryLanguage}` })
            setSupplierImageUrl(data.supplierLogo)
            setCarSupplierNameEN(data.en_supplierName)
            setCarSupplierNameRU(data.ru_supplierName)
            setCarSupplierNameUZ(data.uz_supplierName)
            setContactPersonName(data.contact_person_name)
            setEmail(data.email)
            setPhoneNumber(data.phoneNo)
            setSocialMediaFields(data.socialMediaChannels)
        }
        else {
            toasterrormsg(response.message)
        }
    }
    useEffect(() => {
        if (editCarrentalId != "") {
            carRentalDetailApiCall();
        }
    }, [])


    const criticalFieldChange = (field: string) => {
        Swal.fire({
            title: t('Please note that modifying this detail will require the preparation and signing of a new contract to ensure all parties are in agreement with the revised terms!'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('Ok'),
            cancelButtonText: t('Cancel'),
        }).then(async (result) => {
            if (result.isConfirmed) {
                setIsFieldDisable((prev: any) => ({
                    ...prev,
                    [field]: false,
                }));
            }
        });
    }
    return (
        <>
            <ToastContainer />
            <PageTitle breadcrumbs={[]}>{editCarrentalId != "" ? t('Edit Car Rental') : t('Add Car Rental')}</PageTitle>
            <AddCarRentalHeader carrentalId={editCarrentalId} />
            <div className="d-flex flex-column flex-column-fluid">
                {/* <!--begin::Content--> */}
                <div id="kt_app_content" className="app-content flex-column-fluid">
                    {/* <!--begin::Form--> */}
                    <div className="form d-flex flex-column flex-lg-row">
                        {/* <!--begin::Main column--> */}
                        <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
                            {/* <!--begin::Tab content--> */}
                            <div className="tab-content">
                                {/* <!--begin::Tab pane--> */}
                                <div className="tab-pane fade show active" id="kt_ecommerce_add_product_general" role="tab-panel">
                                    <div className="d-flex flex-column">
                                        {/* <!--begin::General options--> */}
                                        <div className="card card-flush py-4">
                                            {/* <!--begin::Card header--> */}
                                            <div className="card-header d-flex">
                                                {/* <!--begin::Card title--> */}
                                                <div className="card-title">
                                                    <h2>{t('Car Rental Basic Information')}</h2>
                                                </div>
                                                {/* <!--end::Card title--> */}
                                                <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                                                    {
                                                        carRentalDetails.length != 0 ? (
                                                            <>
                                                                {
                                                                    carRentalDetails.map((completedSteps: any, index: any) => {
                                                                        var percentage = 0;
                                                                        if (completedSteps['completedSteps']['basicInfo']) {
                                                                            percentage = 10;
                                                                        }
                                                                        if (completedSteps['completedSteps']['location']) {
                                                                            percentage = 20;
                                                                        }
                                                                        if (completedSteps['completedSteps']['carRentalInfo']) {
                                                                            percentage = 40;
                                                                        }
                                                                        if (completedSteps['completedSteps']['photos']) {
                                                                            percentage = 50;
                                                                        }
                                                                        if (completedSteps['completedSteps']['insurance']) {
                                                                            percentage = 60;
                                                                        }
                                                                        if (completedSteps['completedSteps']['documentsRequired']) {
                                                                            percentage = 70;
                                                                        }
                                                                        if (completedSteps['completedSteps']['availability']) {
                                                                            percentage = 70;
                                                                        }
                                                                        if (completedSteps['completedSteps']['pickupDropoffInfo']) {
                                                                            percentage = 80;
                                                                        }
                                                                        if (completedSteps['completedSteps']['policies']) {
                                                                            percentage = 90;
                                                                        }
                                                                        if (completedSteps['completedSteps']['financeAndLegal']) {
                                                                            percentage = 100;
                                                                        }
                                                                        return (
                                                                            <React.Fragment key={index}>
                                                                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                                    <span className='fw-bold fs-6'>{t('Completion')}</span>
                                                                                    <span className='fw-bolder fs-6'>{percentage}%</span>
                                                                                </div>
                                                                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                                    <div
                                                                                        className='bg-success rounded h-5px'
                                                                                        role='progressbar'
                                                                                        style={{ width: `${percentage}%` }}
                                                                                    ></div>
                                                                                </div>
                                                                            </React.Fragment>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                    <span className='fw-bold fs-6'>{t('Completion')}</span>
                                                                    <span className='fw-bolder fs-6'>0%</span>
                                                                </div>
                                                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                    <div
                                                                        className='bg-success rounded h-5px'
                                                                        role='progressbar'
                                                                        style={{ width: '0%' }}
                                                                    ></div>
                                                                </div>
                                                            </>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            {/* <!--end::Card header--> */}
                                            {/* <!--begin::Card body--> */}
                                            <div className="card-body pt-10">
                                                {/* <!--begin::Input group--> */}
                                                <div className="row">
                                                    <div className="col-lg-12 my-3">
                                                        {/* <!--begin::Image input--> */}
                                                        <div className="image-input image-input-outline " data-kt-image-input="true">
                                                            {/* <!--begin::Preview existing avatar--> */}
                                                            <img id="previewImage" className="image-input-wrapper w-125px h-125px changeimg pointer" src={supplierImage ? URL.createObjectURL(supplierImage) : supplierImageUrl === "" || supplierImageUrl === null ? toAbsoluteUrl("/media/logos/InsayrLogo.png") : supplierImageUrl} />
                                                            {/* <!--end::Preview existing avatar--> */}
                                                            {/* <!--begin::Label--> */}
                                                            <label className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow" data-kt-image-input-action="change" data-bs-toggle="tooltip" title="" data-bs-original-title="Change avatar">
                                                                <i className="fa fa-edit"></i>
                                                                {/* <!--begin::Inputs--> */}
                                                                <input type="file" name="image" id="profileImage" accept=".png, .jpg, .jpeg" style={{ "display": "none" }} onChange={(e: any) => { if (e.target.files[0] != null && e.target.files[0] != undefined) { setSupplierImage(e.target.files[0]); removeError("image") } }} />
                                                                <input type="hidden" name="avatar_remove" />
                                                                {/* <!--end::Inputs--> */}
                                                            </label>
                                                            {/* <!--end::Label--> */}
                                                        </div>
                                                        {/* <!--end::Image input--> */}
                                                        {/* <!--begin::Hint--> */}
                                                        <div className="form-text" id="validimage">{t('Allowed file types: png, jpg, jpeg.')}</div>
                                                        {/* <!--end::Hint--> */}
                                                        <div className='text-danger fw-bold'>{error[0].image}</div>
                                                    </div>
                                                    <div className="col-lg-4 my-3">
                                                        {/* <!--begin::Label--> */}
                                                        <label className="fs-4 form-label required">{t('Primary Language')}</label>
                                                        {/* <!--end::Label--> */}
                                                        {/* <!--begin::Input--> */}
                                                        <Select
                                                            name='primaryLanguage[]'
                                                            id='primaryLanguage'
                                                            placeholder={t('Select Primary Language')}
                                                            isSearchable={true}
                                                            options={primaryLanguageList}
                                                            value={primaryLanguageSelectedOptions}
                                                            onChange={(e: any) => { changePrimaryLanguage(e) }}
                                                        />
                                                        {/* <!--end::Input--> */}
                                                        <div className='text-danger fw-bold'>{error[0].primaryLanguage}</div>
                                                    </div>

                                                </div>
                                                {/* <!--end::Input group--> */}
                                            </div>
                                            {/* <!--end::Card body--> */}
                                            {/* <!--begin::Card body--> */}
                                            <div className="card-body pt-0">
                                                {
                                                    primaryLanguageSelectedOptions.value == "English" && (
                                                        <>
                                                            {/* <!--begin::Input group--> */}
                                                            <div className="row">
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="required fs-4 form-label">{t('Supplier Name (English)')}</label>
                                                                    <button type='button' className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3' onClick={() => criticalFieldChange('carSupplierNameEN')}><KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon></button>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="carSupplierNameEN" disabled={isFieldDisable.carSupplierNameEN} className="form-control mb-2" placeholder={t("Supplier Name")} value={carSupplierNameEN} onChange={(e) => { setCarSupplierNameEN(e.target.value); removeError("carSupplierNameEN"); }} />
                                                                    {/* <!--end::Input--> */}
                                                                    <div className='text-danger fw-bold'>{error[0].carSupplierNameEN}</div>
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Supplier Name (Russian)')}</label>
                                                                    <button type='button' className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3' onClick={() => criticalFieldChange('carSupplierNameRU')}><KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon></button>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="carSupplierNameRU" disabled={isFieldDisable.carSupplierNameRU} className="form-control mb-2" placeholder={t("Supplier Name")} value={carSupplierNameRU} onChange={(e) => { setCarSupplierNameRU(e.target.value) }} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Supplier Name (Uzbek)')}</label>
                                                                    <button type='button' className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3' onClick={() => criticalFieldChange('carSupplierNameUZ')}><KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon></button>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="carSupplierNameUZ" disabled={isFieldDisable.carSupplierNameUZ} className="form-control mb-2" placeholder={t("Supplier Name")} value={carSupplierNameUZ} onChange={(e) => { setCarSupplierNameUZ(e.target.value) }} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Input group--> */}
                                                        </>
                                                    )
                                                }
                                                {
                                                    primaryLanguageSelectedOptions.value == "Russian" && (
                                                        <>
                                                            {/* <!--begin::Input group--> */}
                                                            <div className="row">
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="required fs-4 form-label">{t('Supplier Name (Russian)')}</label>
                                                                    <button type='button' className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3' onClick={() => criticalFieldChange('carSupplierNameRU')}><KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon></button>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="carSupplierNameRU" disabled={isFieldDisable.carSupplierNameRU} className="form-control mb-2" placeholder={t("Supplier Name")} value={carSupplierNameRU} onChange={(e) => { setCarSupplierNameRU(e.target.value) }} />
                                                                    <div className='text-danger fw-bold'>{error[0].carSupplierNameRU}</div>
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Supplier Name (English)')}</label>
                                                                    <button type='button' className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3' onClick={() => criticalFieldChange('carSupplierNameEN')}><KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon></button>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="carSupplierNameEN" disabled={isFieldDisable.carSupplierNameEN} className="form-control mb-2" placeholder={t("Supplier Name")} value={carSupplierNameEN} onChange={(e) => { setCarSupplierNameEN(e.target.value); removeError("carSupplierNameEN"); }} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Supplier Name (Uzbek)')}</label>
                                                                    <button type='button' className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3' onClick={() => criticalFieldChange('carSupplierNameUZ')}><KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon></button>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="carSupplierNameUZ" disabled={isFieldDisable.carSupplierNameUZ} className="form-control mb-2" placeholder={t("Supplier Name")} value={carSupplierNameUZ} onChange={(e) => { setCarSupplierNameUZ(e.target.value) }} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Input group--> */}
                                                        </>
                                                    )
                                                }
                                                {
                                                    primaryLanguageSelectedOptions.value == "Uzbek" && (
                                                        <>
                                                            {/* <!--begin::Input group--> */}
                                                            <div className="row">
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="required fs-4 form-label">{t('Supplier Name (Uzbek)')}</label>
                                                                    <button type='button' className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3' onClick={() => criticalFieldChange('carSupplierNameUZ')}><KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon></button>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="carSupplierNameUZ" disabled={isFieldDisable.carSupplierNameUZ} className="form-control mb-2" placeholder={t("Supplier Name")} value={carSupplierNameUZ} onChange={(e) => { setCarSupplierNameUZ(e.target.value) }} />
                                                                    {/* <!--end::Input--> */}
                                                                    <div className='text-danger fw-bold'>{error[0].carSupplierNameUZ}</div>
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Supplier Name (Russian)')}</label>
                                                                    <button type='button' className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3' onClick={() => criticalFieldChange('carSupplierNameRU')}><KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon></button>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="carSupplierNameRU" disabled={isFieldDisable.carSupplierNameRU} className="form-control mb-2" placeholder={t("Supplier Name")} value={carSupplierNameRU} onChange={(e) => { setCarSupplierNameRU(e.target.value) }} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Supplier Name (English)')}</label>
                                                                    <button type='button' className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3' onClick={() => criticalFieldChange('carSupplierNameEN')}><KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon></button>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="carSupplierNameEN" disabled={isFieldDisable.carSupplierNameEN} className="form-control mb-2" placeholder={t("Supplier Name")} value={carSupplierNameEN} onChange={(e) => { setCarSupplierNameEN(e.target.value); removeError("carSupplierNameEN"); }} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Input group--> */}
                                                        </>
                                                    )
                                                }
                                            </div>
                                            {/* <!--end::Card body--> */}
                                            {/* <!--begin::Card body--> */}
                                            <div className="card-body pt-0">
                                                {/* <!--begin::Input group--> */}
                                                <div className="row">
                                                    <div className="col-lg-4 my-3">
                                                        {/* <!--begin::Label--> */}
                                                        <label className="required fs-4 form-label">{t('Contact Person Name')}</label>
                                                        <button type='button' className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3' onClick={() => criticalFieldChange('contactPersonName')}><KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon></button>
                                                        {/* <!--end::Label--> */}
                                                        {/* <!--begin::Input--> */}
                                                        <input type="text" name="contactPersonName" disabled={isFieldDisable.contactPersonName} className="form-control mb-2" placeholder={t("Contact Person Name")} value={contactPersonName} onChange={(e) => { setContactPersonName(e.target.value); removeError("contactPersonName"); }} />
                                                        {/* <!--end::Input--> */}
                                                        <div className='text-danger fw-bold'>{error[0].contactPersonName}</div>
                                                    </div>
                                                    <div className="col-lg-4 my-3">
                                                        {/* <!--begin::Label--> */}
                                                        <label className="fs-4 form-label required">{t('Email')}</label>
                                                        {/* <!--end::Label--> */}
                                                        {/* <!--begin::Input--> */}
                                                        <input type="text" name="email" className="form-control mb-2" placeholder={t("Email")} value={email} onChange={(e) => { setEmail(e.target.value); removeError("email"); }} />
                                                        {/* <!--end::Input--> */}
                                                        <div className='text-danger fw-bold'>{error[0].email}</div>
                                                    </div>
                                                    <div className="col-lg-4 my-3">
                                                        {/* <!--begin::Label--> */}
                                                        <label className="fs-4 form-label required">{t('Phone Number')}</label>
                                                        {/* <!--end::Label--> */}
                                                        {/* <!--begin::Input--> */}
                                                        <PhoneInput
                                                            inputClass="form-control form-control-lg form-control-solid w-100"
                                                            placeholder={t('Phone Number')}
                                                            enableSearch={true}
                                                            value={phoneNumber}
                                                            onChange={(e) => { setPhoneNumber(e); removeError("phoneNumber"); }}
                                                        />
                                                        {/* <!--end::Input--> */}
                                                        <div className='text-danger fw-bold'>{error[0].phoneNumber}</div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Input group--> */}
                                            </div>
                                            <div className="card-body pt-0">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        {/* <!--begin::Label--> */}
                                                        <label className="fs-4 form-label required">{t('Social Media Channel')}</label>
                                                        {/* <!--end::Label--> */}
                                                    </div>
                                                </div>
                                                {socialMediaFields.map((field: any, index: any) => (
                                                    <div className='row' key={index}>
                                                        <div className="col-lg-4 mb-3">
                                                            <Select
                                                                name='socialMediaChannels[]'
                                                                id={`socialMediaChannels-${index}`}
                                                                placeholder={t('Select Social Media Channels')}
                                                                isSearchable={true}
                                                                options={getFilteredOptions(index)}
                                                                value={socialMediaChannelList.find(option => option.value === field.socialMediaType)}
                                                                onChange={(selectedOption: any) => handleChange(index, 'socialMediaType', selectedOption.value)}
                                                            />
                                                            {errors[index]?.socialMediaType && <div className="text-danger fw-bold">{errors[index].socialMediaType}</div>}
                                                        </div>
                                                        <div className="col-lg-4 mb-3">
                                                            <input
                                                                type="text"
                                                                className='form-control mb-2'
                                                                name='socialMediaLinks'
                                                                id={`socialMediaLinks-${index}`}
                                                                placeholder={t('Social Media Link')}
                                                                value={field.socialMediaLink}
                                                                onChange={(e) => handleChange(index, 'socialMediaLink', e.target.value)}
                                                            />
                                                            {errors[index]?.socialMediaLink && <div className="text-danger fw-bold">{errors[index].socialMediaLink}</div>}
                                                        </div>
                                                        <div className="col-lg-4 mb-3">
                                                            <button className='btn btn-success mx-1' type="button" onClick={handleAddField}>+</button>
                                                            {socialMediaFields.length > 1 && index != 0 && (
                                                                <button className='btn btn-danger mx-1' type="button" onClick={() => handleRemoveField(index)}>-</button>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        {/* <!--end::Pricing--> */}
                                    </div>
                                </div>
                                {/* <!--end::Tab pane--> */}
                            </div>
                            {/* <!--end::Tab content--> */}
                            <div className="d-flex justify-content-end">
                                {/* <!--begin::Button--> */}
                                <Link to="../viewcarrentals/" id="kt_ecommerce_add_product_cancel" className="btn btn-light me-5">{t('Cancel')}</Link>
                                {/* <!--end::Button--> */}
                                <button type="submit" disabled={disable} className="btn btn-primary" onClick={() => { if (editCarrentalId !== "") { editCarRentalApi(); } else { addCarRentalApi(); } }}>
                                    <span className="indicator-label">{t('Next')}</span>
                                    {loading && (
                                        <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                    )}
                                </button>
                                {/* <!--end::Button--> */}
                            </div>
                        </div>
                        {/* <!--end::Main column--> */}
                    </div>
                    {/* <!--end::Form--> */}
                </div>
                {/* <!--end::Content--> */}
            </div>
        </>
    )
}

export { AddCarRentalBasicInfo }
